<template>
  <div>
    <el-table
      style="width: 100%"
      width="100%"
      class="table-xs"
      :data="SiteKasa"
      show-summary
      :summary-method="TableFooter"
      row-key="id"
      :height="Height"
      default-expand-all>
      <el-table-column
        prop="Adi"
        label="Bina Adı">
      </el-table-column>
      <el-table-column
        prop="BlokeText"
        label="Bloke"
        align="right"
        width="90">
      </el-table-column>
      <el-table-column
        prop="GelirText"
        label="Gelir"
        align="right"
        width="100">
      </el-table-column>
      <el-table-column
        prop="GiderText"
        label="Gider"
        align="right"
        width="100">
      </el-table-column>
      <el-table-column
        prop="BakiyeText"
        label="Bakiye"
        align="right"
        width="100">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: ["SiteKasa", "AltToplam", "SirketKasa"],
  data() {
    return {
      Height: null,
    }
  },
  methods: {
    TableFooter() {
      const sums = [];
      sums[1] = this.AltToplam.Bloke;
      sums[2] = this.AltToplam.Gelir;
      sums[3] = this.AltToplam.Gider;
      sums[4] = this.AltToplam.Bakiye;
      return sums;
    },
  },
  created() {
    // console.log(this.SirketKasa)
    if (this.SirketKasa) this.Height = (window.innerHeight / 2) - 80; else this.Height = (window.innerHeight / 2) - 120;
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Yonetim/bina/Ekran/Detay/SiteKasa.vue